(function() {
    'use strict';

    angular.module('product')
        .controller('ProductParameterUpdateController', ProductParameterUpdateController);

    ProductParameterUpdateController.$inject = ['$state', '$uibModal', 'productParameterDataSrvc', 'productParameterOptionDataSrvc', 'notificationSrvc', 'productParameterMessagesConst', 'productParameterOptionPermissionsConst', 'checkModelPermissionsSrvc', 'errorNotificationSrvc'];

    function ProductParameterUpdateController($state, $uibModal, productParameterDataSrvc, productParameterOptionDataSrvc, notificationSrvc, productParameterMessagesConst, productParameterOptionPermissionsConst, checkModelPermissionsSrvc, errorNotificationSrvc) {
        var self = this;

        self.loading = true;

        self.serverErrors = {
            name_pl: [],
            name_en: [],
            name_de: [],
            name_cpde: [],
            name_cpen: [],
            var_name: [],
            nonFieldErrors: []
        };
        self.productParameterData = {};
        self.updateProductParameter = updateProductParameter;
        self.cleanErrors = cleanErrors;

        self.optionCols = [{
            title: 'Nazwa PL',
            value: 'name_pl',
            type: 'text'
        }, {
            title: 'Nazwa EN',
            value: 'name_en',
            type: 'text'
        }, {
            title: 'Nazwa DE',
            value: 'name_de',
            type: 'text'
        }, {
            title: 'Nazwa EN (DE)',
            value: 'name_cpen',
            type: 'text'
        }, {
            title: 'Nazwa DE (DE)',
            value: 'name_cpde',
            type: 'text'
        }];
        self.hasProductParameterOptionViewPermission = hasProductParameterOptionViewPermission;
        self.modelPermissions = productParameterOptionPermissionsConst;
        self.onOptionCreate = onOptionCreate;
        self.onOptionEdit = onOptionEdit;
        self.onOptionDelete = onOptionDelete;
        self.onOptionReorder = onOptionReorder;

        activate();

        function activate() {
            getProductParameter();
        }

        function getProductParameter() {
            self.loading = true;

            return productParameterDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.productParameterData = response;

                for (var i = 0; i < self.productParameterData.options.length; ++i) {
                    delete self.productParameterData.options[i].date_added;
                    delete self.productParameterData.options[i].date_modified;
                }
                return response;
            }).finally(function(response) {
                self.loading = false;
                return response;
            });
        }

        function updateProductParameter() {
            return productParameterDataSrvc.update({
                pk: self.productParameterData.pk
            }, self.productParameterData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", productParameterMessagesConst.update);
                    $state.go('layout.productParameter.list');
                    return response;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function hasProductParameterOptionViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                productParameterOptionPermissionsConst.view);
        }

        function onOptionCreate() {
            $uibModal.open({
                templateUrl: 'app/product/views/product-parameter-option-create/product-parameter-option-create.html',
                controller: 'ProductParameterOptionCreateController',
                controllerAs: 'ctrl'
            }).result.then(
                function(result) {
                    self.productParameterData.options.unshift(result);
                    return result;
                }
            );
        }

        function onOptionEdit(row) {
            $uibModal.open({
                templateUrl: 'app/product/views/product-parameter-option-update/product-parameter-option-update.html',
                controller: 'ProductParameterOptionUpdateController',
                controllerAs: 'ctrl',
                resolve: {
                    row: function() {
                        return row;
                    }
                }
            }).result.then(
                function(result) {
                    var index = self.productParameterData.options.indexOf(row);
                    self.productParameterData.options[index] = result;
                    return result;
                }
            );
        }

        function onOptionDelete(row) {
            var index = self.productParameterData.options.indexOf(row);
            self.productParameterData.options.splice(index, 1);
        }

        function onOptionReorder(row, newPos) {
            row.position = newPos;
            return productParameterOptionDataSrvc.update({
                pk: row.pk
            }, {
                position: row.position
            }).$promise.then(
                function(response) {
                    return response;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }
    }
})();
